import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown } from "@fortawesome/free-solid-svg-icons";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import { Edit, Trash2 } from "lucide-react";
import styles from "../../clients.module.scss";
import { Button } from "../../../../components/ui/button";
import { Card, CardContent } from "../../../../components/ui/card";

export default function ContactsList({
  stepContent,
  isMobile,
  setSelectedContact,
  setContactType,
  setOpenDailog,
  setReinviteDialog,
  handleEditContact,
  setEdit,
  setOpenRevokeDialog,
  setDeleteDialog,
  setTemptData
}) {
  if (
    !(stepContent?.primary?.length > 0 || stepContent?.additional?.length > 0)
  ) {
    return null;
  }

  const renderContact = (contact, type) => (
    <div key={contact.id} className={styles.contactItem}>
      <div className="d-flex">
        <div
          style={{
            backgroundColor: "#DBEAFE",
            color: "#1D4ED8",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            marginRight: "5px",
            textTransform: "uppercase",
          }}
        >
          {contact?.name ? contact.name.charAt(0) : "?"}
        </div>
        <div className="ml-8">
          <p className={`${styles.contactName} dark:text-white`}>
            {contact?.name}
            {type === "primary" && (
              <span
                className="ml-5 p-5"
                style={{
                  backgroundColor: "#FFFBEB",
                  color: "#B45309",
                  fontSize: "12px",
                  borderRadius: "20px",
                  border: "1px solid rgb(253 230 138 / 1)",
                }}
              >
                <FontAwesomeIcon icon={faCrown} fontSize={"small"} /> Primary
              </span>
            )}
          </p>
          <div className={styles.contactDetails}>
            <span className={`${styles.contactInfos} dark:text-white`}>
              <MailOutlineIcon className={styles.iconSm} fontSize="small" />{" "}
              {contact?.email}
            </span>
            {contact?.mobileNumber && (
              <span className={`${styles.contactInfoLink} dark:text-white`}>
                <CallOutlinedIcon className={styles.iconSm} fontSize="small" />{" "}
                {contact?.mobileNumber}
              </span>
            )}
          </div>
        </div>
      </div>

      <div>
        <div className={isMobile ? "d-flex mv-10" : "d-flex"}>
          {contact?.invite !== true && (
            <Button
              className={styles.contactInviteActions}
              variant="outlined"
              onClick={() => {
                setSelectedContact(contact);
                setContactType(type);
                setOpenDailog(true);
              }}
            >
              <PersonOutlineOutlinedIcon fontSize="small" />{" "}
              <span className="ml-10">Invite</span>
            </Button>
          )}
          {contact?.invite === true && (
            <Button
              className={styles.contactInviteActions}
              variant="outlined"
              onClick={() => {
                setSelectedContact(contact);
                setContactType(type);
                setReinviteDialog(true);
              }}
            >
              <PersonOutlineOutlinedIcon fontSize="small" />{" "}
              <span className="ml-10">Re-Invite</span>
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              handleEditContact(contact, type);
              setEdit(true);
            }}
            className="flex items-center gap-1.5 color-primary hover:text-primary hover:bg-primary/5"
            style={{ height: "30px" }}
          >
            <Edit className="h-3.5 w-3.5 mr-4" />
            <span>Edit</span>
          </Button>
        </div>

        <div className="mt-6 d-flex flex-justify-end">
          {contact?.invite === true && contact?.login && (
            <Button
              className={`${styles.contactRevokeActions} mr-0`}
              variant="outlined"
              onClick={() => {
                setSelectedContact(contact);
                setContactType(type);
                setOpenRevokeDialog(true);
              }}
            >
              <PersonRemoveOutlinedIcon fontSize="small" />{" "}
              <span className="ml-10">Revoke Invite</span>
            </Button>
          )}

          {type === "additional" && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                setDeleteDialog(true);
                setTemptData({
                  type: "additional",
                  email: contact?.email,
                });
              }}
              style={{ height: "30px" }}
              className="h-9 text-red-500 border-red-200 hover:bg-red-50 hover:text-red-600 hover:border-red-300"
            >
              <Trash2 className="h-4 w-4 mr-6" /> Delete
            </Button>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="mb-20">
      <Card
        className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
      >
        <CardContent className="p-24">
          <h3 className={`${styles.contactsTitle} dark:text-white`}>
            Existing Contacts
          </h3>
          <div className={styles.contactsList}>
            {stepContent?.primary?.map((contact) =>
              renderContact(contact, "primary")
            )}
            {stepContent?.additional?.map((contact) =>
              renderContact(contact, "additional")
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}